import { render, staticRenderFns } from "./friendsPage.vue?vue&type=template&id=2d2d734a"
import script from "./friendsPage.vue?vue&type=script&lang=js"
export * from "./friendsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports